export default {
    SET_NOTIFICATIONS_DATA(state, data) {
        state.notifications = data;
    },
    SET_NOTIFICATIONS_ALL_DATA(state, data) {
        state.notificationsList = data;
    },
};